var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactEmailWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2156_3040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5H5C2.2425 2.5 0 4.7425 0 7.5V17.5H20V7.5C20 4.7425 17.7575 2.5 15 2.5ZM9.16667 16.6667H0.833333V7.5C0.833333 5.2025 2.7025 3.33333 5 3.33333C7.2975 3.33333 9.16667 5.2025 9.16667 7.5V16.6667ZM19.1667 16.6667H10V7.5C10 5.7625 9.10917 4.23 7.76083 3.33333H15C17.2975 3.33333 19.1667 5.2025 19.1667 7.5V16.6667ZM11.6667 8.33333H16.6667V11.6667H15.8333V9.16667H11.6667V8.33333ZM3.33333 8.33333H6.66667V9.16667H3.33333V8.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2156_3040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactEmailWhite);
export default __webpack_public_path__ + "static/media/icon_contact_email_white.79f087691cc272a6047a6c90370bff9f.svg";
export { ForwardRef as ReactComponent };